import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL_ADMIN;

/**
 * Attach Bearer token from localStorage to every request.
 */
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Backend returns HTTP 200 with `{ status, message, data }` in the body.
 * Reject when body.status is present and not a 2xx code.
 */
axios.interceptors.response.use(
  (response) => {
    const bodyStatus = response?.data?.status;
    if (bodyStatus != null && (bodyStatus < 200 || bodyStatus >= 300)) {
      const message = response.data?.message || 'Request failed';
      const err = new Error(message);
      err.response = response;
      return Promise.reject(err);
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export { baseURL };
export default axios;
